export default class UserActions{
    static USER_PROFILE_REQUEST:string = "USER_PROFILE_REQUEST";
    static USER_PROFILE_SUCCESS:string = "USER_PROFILE_SUCCESS";
    static USER_PROFILE_ERROR: string = "USER_PROFILE_ERROR";
}